import type { InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetVulnerabilities = ApiClient['v1']['vulnerabilities']['$get'];
export type VulnerabilitiesListResponse = InferResponseType<GetVulnerabilities, 200>;
export type VulnerabilityResponse = VulnerabilitiesListResponse['vulnerabilities'][number];

type UseVulnerabilitiesParams = {
  workspaceId: number;
  includeDismissed?: boolean;
};

// includeDismissed is API-only for now - the overview table has no dismissal toggle yet.
export function useVulnerabilities({ workspaceId, includeDismissed }: UseVulnerabilitiesParams) {
  return useFetch<VulnerabilitiesListResponse>(
    `vulnerabilities?${JSON.stringify({ workspaceIdIn: [workspaceId], includeDismissed })}`,
    (client) =>
      client.v1.vulnerabilities.$get({
        query: {
          workspaceIdIn: workspaceId.toString(),
          ...(includeDismissed === undefined
            ? {}
            : { isDismissed: includeDismissed ? ('true' as const) : ('false' as const) }),
        },
      })
  );
}
